<div class="mx-thumbnail-container">
    <div *ngIf="!thumbnailUrl || !imageLoaded" class="mx-centered-container">
        <div class="mx-logo-wrapper">
            <span class="mx-centered-container">
                <i class="material-icons">{{defaultThumbnailClass}}</i>
            </span>
        </div>
    </div>

    <div *ngIf="thumbnailUrl" class="mx-thumbnail-img-container">
        <ng-container *ngIf="thumbnailUrl | secureImg | async as url">
            <img class="mx-thumbnail" (load)="load()" [src]="url.url">
        </ng-container>

    </div>
</div>
